export enum SortOptions {
  NO_PREFERENCE = "Sem Preferência",
  HIGHEST_PRICE = "Maior Preço",
  LOWEST_PRICE = "Menor Preço",
}
